import { createContext, useContext } from 'react';

export const AppBarContext = createContext(null);
export const useAppBar = () => useContext(AppBarContext);
